import { bindActionCreators } from 'redux';

import { logout, getUserProgress, resetStore, removeUser } from 'pages/Login/actions';

function containerActions(dispatch) {
  return bindActionCreators(
    {
      logout,
      getUserProgress,
      resetStore,
      removeUser
    },
    dispatch
  );
}

export default containerActions;



// WEBPACK FOOTER //
// ./src/pages/Profile/actions.js